import { __extends } from "tslib";
import { CompositeMethodBase } from './CompositeMethodBase';
import { SpecularBasicMethod } from './SpecularBasicMethod';
/**
 * SpecularCompositeMethod provides a base class for specular methods that wrap
 * a specular method to alter the calculated specular reflection strength.
 */
var SpecularCompositeMethod = /** @class */ (function (_super) {
    __extends(SpecularCompositeMethod, _super);
    /**
     * Creates a new <code>SpecularCompositeMethod</code> object.
     *
     * @param modulateMethod The method which will add the code to alter the
     * base method's strength. It needs to have the signature
     * clampDiffuse(t:ShaderRegisterElement,
     * regCache:ShaderRegisterCache):string, in which t.w will contain the
     * diffuse strength.
     * @param baseMethod The base specular method on which this method's shading
     * is based.
     */
    function SpecularCompositeMethod(baseMethod) {
        if (baseMethod === void 0) { baseMethod = null; }
        return _super.call(this, baseMethod) || this;
    }
    SpecularCompositeMethod.prototype.createBaseMethod = function () {
        return new SpecularBasicMethod();
    };
    Object.defineProperty(SpecularCompositeMethod.prototype, "gloss", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.gloss;
        },
        set: function (value) {
            this._baseMethod.gloss = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpecularCompositeMethod.prototype, "strength", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.strength;
        },
        set: function (value) {
            this._baseMethod.strength = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpecularCompositeMethod.prototype, "color", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.color;
        },
        /**
         * @inheritDoc
         */
        set: function (value) {
            this._baseMethod.color = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpecularCompositeMethod.prototype, "texture", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.texture;
        },
        set: function (value) {
            this._baseMethod.texture = value;
        },
        enumerable: false,
        configurable: true
    });
    return SpecularCompositeMethod;
}(CompositeMethodBase));
export { SpecularCompositeMethod };
